import angular from 'angular';
import staticViewsConfig from "./static-views.config";

let staticViewsModule = angular.module('shared.components.staticViews', [])
  .config(staticViewsConfig);

export default staticViewsModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/static-views/static-views.js
 **/